// extracted by mini-css-extract-plugin
export default {"page":"ModernPageShell_page__qZ651","container":"ModernPageShell_container__V8N1X","hero":"ModernPageShell_hero__BvOw9"};